// extracted by mini-css-extract-plugin
export var company = "Company--company--2p9fE";
export var company__details = "Company--company__details--lOsCz";
export var company__logo = "Company--company__logo--Lf0A0";
export var tkMyriadProSemiCondensed = "Company--tk-myriad-pro-semi-condensed--K3qEJ";